// removed by extract-text-webpack-plugin
module.exports = {"profileContainer":"Profile-view__profileContainer___2aoxW","loaderContainer":"Profile-view__loaderContainer___2lFb3"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Profile-view/Profile-view.scss
// module id = 1581
// module chunks = 0